import { InjectionToken } from '@angular/core';
import { AbandonmentConfig } from '@auth-n/abandonment/abandonment-config';

export const AbandonmentConfigInjectionToken = new InjectionToken<AbandonmentConfig>('AbandonmentConfig');
